import Joi from 'joi-browser';
import { DashboardTabSegments } from "../../../../common/routing";
import SectionAnchorLink from "../../../../components/Headers/SectionAnchorLink";
import * as React from 'react';
import WithAuth from '../../../../components/Auth/WithAuth';
import Form from '../../../../components/Elements/Form';
import globalStyles from '../../../../index.module.scss';
import { submitSupportTicket } from '../../../../services/business/marketplaceService';
import { General } from '../../../../common/constants';
import queryString from 'query-string';
import { withRouter } from 'react-router';
import { Success } from '../../../../components/Alerts/Success';
import { Error } from '../../../../components/Alerts/Error';

const RequestStatus = {
    Success: 'Success',
    Failure: 'Failure'
}
class TicketSubmission extends Form {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            requestState: '',
            appSpaceId: props.appSpaceId,
            productId: props.productId,
            errors: {},
            data: {
                subject: '',
                description: ''
            }
        };
    }

    schema = {
        subject: Joi.string()
            .min(1)
            .max(100)
            .required()
            .label("Subject")
            .error(() => {
                return {
                    message: "Subject is required (max 100 characters).",
                };
            }),
        description: Joi.string()
            .min(50)
            .required()
            .label("What do you need help with?")
            .error(() => {
                return {
                    message: "Request description is required (min 50 characters).",
                };
            }),
    }

    onSubmit = async (e) => {
        if (this.isFormValid()) {

            this.handleSubmit(e);

            this.setState({
                ...this.state,
                loading: true
            })

            let ticket = {
                title: this.state.data.subject,
                description: this.state.data.description,
                appSpaceId: this.state.appSpaceId,
                productId: this.state.productId
            }

            let response = await submitSupportTicket({
                ticket,
                accessToken: this.props.accessToken,
                refreshToken: this.props.refreshToken
            });

            if (response.success) {
                this.setState({
                    ...this.state,
                    requestState: {
                        type: RequestStatus.Success,
                        ticketNumber: response.ticketId
                    },
                    data: {
                        subject: '',
                        description: ''
                    },
                    loading: false,
                    loadedWithError: false
                });
            }
            else if (response.failed) {
                if (response.code === 'DuplicateSuppoerRequest') {
                    this.setState({
                        ...this.state,
                        requestState: {
                            type: RequestStatus.Failure,
                            message: response?.userFriendlyMessage
                        },
                        loading: false,
                        loadedWithError: true
                    });
                }
                else {
                    this.setState({
                        ...this.state,
                        requestState: {
                            type: RequestStatus.Failure,
                            message: `There was a problem submitting the support request, make sure Internt connectivity is OK. Please retry shortly and if the problem persisted, contact our support team at ${General.ContactDetails.SupportEmailAddress}`
                        },
                        loading: false,
                        loadedWithError: true
                    });
                }
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        var params = queryString.parse(this.props.location.search);
        if (prevProps.productId !== this.props.productId) {
            this.setState({
                appSpaceId: this.props.appSpaceId ?? params.appSpaceId,
                productId: this.props.productId ?? params.productId,
                data: {
                    subject: '',
                    description: ''
                }
            });
        }
    }

    componentDidMount = () => {
        var params = queryString.parse(this.props.location.search);
        this.setState({
            ...this.state,
            appSpaceId: this.props.appSpaceId ?? params.appSpaceId,
            productId: this.props.productId ?? params.productId
        });
    }

    render() {
        return (
            <div>
                <h6 id={DashboardTabSegments.Help}>Support Request<SectionAnchorLink anchorId={DashboardTabSegments.Help} className="ml-2" /></h6>
                <p>Share the challenge you are facing, and one of our team members will be in touch.</p>
                <form onSubmit={(event) => this.onSubmit(event)}>
                    {this.renderInput({
                        name: "subject",
                        label: "Subject",
                        requiredFlag: true,
                    })}

                    {this.renderInput({
                        name: "description",
                        label: "Description",
                        type: 'textArea',
                        requiredFlag: true,
                    })}

                    {this.renderSubmitButton({
                        name: 'Create Support Ticket',
                        className: globalStyles.leftAction,
                        loading: this.state.loading
                    })}

                </form>
                <div className='my-5'>
                    {this.state.requestState.type === RequestStatus.Success &&
                        <Success title="Success">
                            <p>Ticket was submitted successfully, ticket number is: <b>{this.state.requestState.ticketNumber}</b>, our team will be in touch shortly.</p>
                        </Success>
                    }

                    {this.state.requestState.type === RequestStatus.Failure &&
                        <Error title="Failed">
                            {this.state.requestState?.message && <p>{this.state.requestState?.message}</p>}
                        </Error>
                    }
                </div>
            </div >
        );
    }
};

export default WithAuth(withRouter(TicketSubmission));